var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _radialGradient, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProtection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -80 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 198.2438749868,
    x2: 383.1692187606,
    y1: -7.6389088082,
    y2: 211.7640278194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8be1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1873,
    stopColor: "#87e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3558,
    stopColor: "#7ce2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5172,
    stopColor: "#6ae2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6741,
    stopColor: "#50e4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8278,
    stopColor: "#2fe5c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9772,
    stopColor: "#07e7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e7b2"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 271.900728597,
    x2: 271.900728597,
    y1: 126.7189842178,
    y2: 173.947591178
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#00e7b2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4308,
    stopColor: "#1bc4b7",
    stopOpacity: 0.427451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b9abe"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 100.5248180962,
    x2: 258.894417126,
    xlinkHref: "#c",
    y1: 45.1919844808,
    y2: 45.1919844808
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 100.5248180962,
    x2: 258.894417126,
    xlinkHref: "#c",
    y1: 79.7506942322,
    y2: 79.7506942322
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 100.5248180962,
    x2: 226.6340864014,
    xlinkHref: "#c",
    y1: 114.3094039836,
    y2: 114.3094039836
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1596,
    stopColor: "#ff6440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    stopColor: "#ff4b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7662,
    stopColor: "#ff216e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0084"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 310.2361929124,
    x2: 445.0846022276,
    xlinkHref: "#g",
    y1: 79.7506942322,
    y2: 79.7506942322
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0084",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    stopColor: "#f4087e",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    stopColor: "#d2216b",
    stopOpacity: 0.333333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#ba335e",
    stopOpacity: 0.584314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#ab3d56",
    stopOpacity: 0.811765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 440.907985531,
    x2: 352.9675304892,
    xlinkHref: "#i",
    y1: 151.583722745,
    y2: 63.6432677032
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 367.8186490274,
    x2: 401.686258874,
    y1: 78.5036223238,
    y2: 112.3712321704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8567,
    stopColor: "#0b9cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d94fe"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 152.3875290084,
    x2: 332.2553145306,
    y1: 136.0963184432,
    y2: 336.1094051706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 209.904529409,
    x2: 209.904529409,
    y1: 247.0234751268,
    y2: 294.252082087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#bfdcfd",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3251"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5286189082,
    x2: 196.8981175458,
    xlinkHref: "#n",
    y1: 165.4964753898,
    y2: 165.4964753898
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5286189082,
    x2: 196.8981175458,
    xlinkHref: "#n",
    y1: 200.0551851412,
    y2: 200.0551851412
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5286189082,
    x2: 164.6378872134,
    xlinkHref: "#n",
    y1: 234.6139952848,
    y2: 234.6139952848
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 315.664198382,
    cy: 200.0551851412,
    gradientUnits: "userSpaceOnUse",
    r: 67.4242046576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2296,
    stopColor: "#ffd355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4362,
    stopColor: "#ffcf4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#ffc838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb400"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 378.911786343,
    x2: 290.9713313012,
    y1: 271.8883140462,
    y2: 183.9478590044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0396,
    stopColor: "#e27f04",
    stopOpacity: 0.039216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#c15d2f",
    stopOpacity: 0.466667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#ad4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 305.8224498394,
    x2: 339.690059686,
    xlinkHref: "#g",
    y1: 198.808213625,
    y2: 232.6758234716
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 244.5786901904,
    x2: 424.4464757126,
    xlinkHref: "#g",
    y1: 208.1029250698,
    y2: 408.1160117972
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 302.095690591,
    x2: 302.095690591,
    xlinkHref: "#i",
    y1: 319.0301821456,
    y2: 366.2586887136
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 130.7197800902,
    x2: 289.0892787278,
    xlinkHref: "#c",
    y1: 237.5030820164,
    y2: 237.5030820164
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 130.7197800902,
    x2: 289.0892787278,
    xlinkHref: "#c",
    y1: 272.0617917678,
    y2: 272.0617917678
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 130.7197800902,
    x2: 256.8290483954,
    xlinkHref: "#c",
    y1: 306.6206019114,
    y2: 306.6206019114
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientUnits: "userSpaceOnUse",
    x1: 340.4311549064,
    x2: 475.2794638294,
    xlinkHref: "#n",
    y1: 272.0617917678,
    y2: 272.0617917678
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 471.102947525,
    x2: 383.162392091,
    y1: 343.8949206728,
    y2: 255.954465631
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3251",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 398.0136110214,
    x2: 431.881220868,
    y1: 270.8148202516,
    y2: 304.6824300982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8be1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1426,
    stopColor: "#7fe2de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4015,
    stopColor: "#5fe3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    stopColor: "#2be5c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e7b2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m456.445312 159.5h-369.089843c-14.007813 0-25.359375-11.351562-25.359375-25.359375v-108.78125c0-14.007813 11.351562-25.359375 25.359375-25.359375h369.089843c14.007813 0 25.359376 11.351562 25.359376 25.359375v108.78125c0 14.007813-11.351563 25.359375-25.359376 25.359375zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m61.996094 79.75v54.390625c0 14.007813 11.351562 25.359375 25.359375 25.359375h369.089843c14.007813 0 25.359376-11.351562 25.359376-25.359375v-54.390625zm0 0",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m100.523438 38.199219h158.371093v13.984375h-158.371093zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m100.523438 72.757812h158.371093v13.984376h-158.371093zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m100.523438 107.316406h126.109374v13.984375h-126.109374zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m433.230469 147.175781h-111.140625c-6.546875 0-11.855469-5.308593-11.855469-11.851562v-111.144531c0-6.546876 5.308594-11.855469 11.855469-11.855469h111.140625c6.546875 0 11.855469 5.308593 11.855469 11.855469v111.144531c0 6.542969-5.308594 11.851562-11.855469 11.851562zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m445.085938 135.324219v-57.582031l-48.195313-48.195313c-4.757813-5.234375-11.617187-8.523437-19.226563-8.523437-14.328124 0-25.984374 11.65625-25.984374 25.984374v21.308594c-1.742188.394532-3.480469.824219-5.214844 1.296875-2.28125.625-3.863282 2.707031-3.863282 5.074219v54.488281c0 1.871094 1 3.550781 2.542969 4.488281l13.511719 13.511719h74.578125c6.542969 0 11.851563-5.308593 11.851563-11.851562zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m408.859375 69.613281c-1.734375-.472656-3.472656-.902343-5.210937-1.296875v-21.308594c0-14.328124-11.660157-25.984374-25.984376-25.984374-14.328124 0-25.984374 11.65625-25.984374 25.984374v21.308594c-1.742188.394532-3.480469.824219-5.214844 1.296875-2.28125.625-3.863282 2.707031-3.863282 5.074219v54.488281c0 2.363281 1.582032 4.445313 3.863282 5.070313 20.664062 5.640625 41.730468 5.640625 62.394531 0 2.28125-.625 3.859375-2.703125 3.859375-5.070313v-54.488281c0-2.367188-1.578125-4.449219-3.859375-5.074219zm-48.183594-22.605469c0-9.363281 7.621094-16.984374 16.984375-16.984374 9.367188 0 16.984375 7.621093 16.984375 16.984374v19.628907c-11.300781-1.664063-22.667969-1.664063-33.96875 0zm22.574219 60.875c-1.617188 1.207032-2.523438 3.148438-2.523438 5.164063v4.027344c0 1.710937-1.402343 3.097656-3.121093 3.066406-1.691407-.03125-3.007813-1.476563-3.007813-3.167969v-3.820312c0-2.070313-.925781-4.058594-2.574218-5.308594-2.414063-1.832031-3.910157-4.808594-3.671876-8.125.328126-4.589844 4.050782-8.308594 8.644532-8.625 5.457031-.378906 10 3.9375 10 9.308594 0 3.0625-1.46875 5.777344-3.746094 7.480468zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m394.449219 279.804688h-369.089844c-14.007813 0-25.359375-11.351563-25.359375-25.359376v-108.78125c0-14.003906 11.351562-25.359374 25.359375-25.359374h369.089844c14.007812 0 25.359375 11.355468 25.359375 25.359374v108.78125c0 14.007813-11.351563 25.359376-25.359375 25.359376zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m0 200.054688v54.390624c0 14.007813 11.351562 25.359376 25.359375 25.359376h369.089844c14.007812 0 25.359375-11.351563 25.359375-25.359376v-54.390624zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m38.527344 158.503906h158.371094v13.984375h-158.371094zm0 0",
    fill: "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m38.527344 193.0625h158.371094v13.984375h-158.371094zm0 0",
    fill: "url(#p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m38.527344 227.621094h126.109375v13.984375h-126.109375zm0 0",
    fill: "url(#q)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m371.234375 267.480469h-111.140625c-6.546875 0-11.855469-5.308594-11.855469-11.855469v-111.144531c0-6.542969 5.308594-11.847657 11.855469-11.847657h111.144531c6.542969 0 11.851563 5.304688 11.851563 11.847657v111.148437c0 6.542969-5.308594 11.851563-11.855469 11.851563zm0 0",
    fill: "url(#r)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m383.089844 255.628906v-57.582031l-48.195313-48.195313c-4.757812-5.234374-11.617187-8.523437-19.226562-8.523437-14.328125 0-25.988281 11.65625-25.988281 25.984375v21.308594c-1.738282.394531-3.476563.824218-5.210938 1.296875-2.28125.625-3.863281 2.707031-3.863281 5.074219v54.488281c0 1.871093 1 3.550781 2.542969 4.488281l13.511718 13.511719h74.578125c6.542969 0 11.851563-5.308594 11.851563-11.851563zm0 0",
    fill: "url(#s)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m346.863281 189.917969c-1.734375-.472657-3.472656-.902344-5.210937-1.296875v-21.308594c0-14.328125-11.660156-25.984375-25.984375-25.984375-14.328125 0-25.988281 11.65625-25.988281 25.984375v21.308594c-1.738282.394531-3.476563.824218-5.210938 1.296875-2.28125.625-3.863281 2.707031-3.863281 5.074219v54.488281c0 2.367187 1.582031 4.449219 3.863281 5.070312 20.664062 5.640625 41.726562 5.640625 62.394531 0 2.28125-.621093 3.859375-2.703125 3.859375-5.070312v-54.488281c0-2.367188-1.578125-4.449219-3.859375-5.074219zm-48.183593-22.605469c0-9.367188 7.621093-16.984375 16.984374-16.984375 9.367188 0 16.984376 7.621094 16.984376 16.984375v19.628906c-11.300782-1.664062-22.667969-1.664062-33.96875 0zm22.570312 60.875c-1.613281 1.207031-2.519531 3.148438-2.519531 5.164062v4.027344c0 1.710938-1.402344 3.097656-3.121094 3.066406-1.691406-.03125-3.007813-1.476562-3.007813-3.167968v-3.824219c0-2.066406-.925781-4.054687-2.574218-5.304687-2.414063-1.832032-3.910156-4.808594-3.671875-8.125.328125-4.59375 4.050781-8.308594 8.644531-8.628907 5.457031-.378906 10 3.941407 10 9.3125 0 3.058594-1.46875 5.777344-3.75 7.480469zm0 0",
    fill: "url(#t)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m486.640625 351.8125h-369.089844c-14.007812 0-25.359375-11.355469-25.359375-25.359375v-108.78125c0-14.007813 11.351563-25.359375 25.359375-25.359375h369.089844c14.007813 0 25.359375 11.351562 25.359375 25.359375v108.78125c0 14.003906-11.351562 25.359375-25.359375 25.359375zm0 0",
    fill: "url(#u)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m92.191406 272.0625v54.390625c0 14.003906 11.351563 25.359375 25.359375 25.359375h369.089844c14.007813 0 25.359375-11.355469 25.359375-25.359375v-54.390625zm0 0",
    fill: "url(#v)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m130.71875 230.511719h158.371094v13.984375h-158.371094zm0 0",
    fill: "url(#w)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m130.71875 265.070312h158.371094v13.984376h-158.371094zm0 0",
    fill: "url(#x)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m130.71875 299.628906h126.109375v13.984375h-126.109375zm0 0",
    fill: "url(#y)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m463.425781 339.484375h-111.144531c-6.542969 0-11.847656-5.304687-11.847656-11.851563v-111.144531c0-6.542969 5.304687-11.851562 11.847656-11.851562h111.148438c6.542968 0 11.851562 5.304687 11.851562 11.851562v111.148438c0 6.542969-5.308594 11.847656-11.855469 11.847656zm0 0",
    fill: "url(#z)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m475.28125 327.632812v-57.578124l-48.195312-48.195313c-4.757813-5.234375-11.617188-8.523437-19.230469-8.523437-14.328125 0-25.984375 11.65625-25.984375 25.984374v21.308594c-1.738282.394532-3.476563.824219-5.210938 1.296875-2.28125.625-3.863281 2.703125-3.863281 5.074219v54.488281c0 1.871094 1 3.550781 2.542969 4.484375l13.511718 13.511719h74.578126c6.542968 0 11.851562-5.304687 11.851562-11.851563zm0 0",
    fill: "url(#A)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m439.054688 261.925781c-1.734376-.472656-3.472657-.902343-5.214844-1.296875v-21.308594c0-14.328124-11.65625-25.984374-25.984375-25.984374s-25.984375 11.65625-25.984375 25.984374v21.308594c-1.738282.390625-3.476563.824219-5.210938 1.296875-2.28125.625-3.863281 2.703125-3.863281 5.074219v54.488281c0 2.363281 1.582031 4.445313 3.863281 5.070313 20.664063 5.640625 41.726563 5.640625 62.394532 0 2.28125-.625 3.859374-2.707032 3.859374-5.070313v-54.488281c0-2.367188-1.578124-4.449219-3.859374-5.074219zm-48.183594-22.605469c0-9.367187 7.621094-16.984374 16.984375-16.984374 9.367187 0 16.984375 7.617187 16.984375 16.984374v19.625c-11.300782-1.664062-22.667969-1.664062-33.96875 0zm22.570312 60.871094c-1.613281 1.207032-2.519531 3.148438-2.519531 5.167969v4.023437c0 1.714844-1.402344 3.101563-3.121094 3.070313-1.691406-.03125-3.007812-1.476563-3.007812-3.171875v-3.820312c0-2.066407-.925781-4.058594-2.574219-5.304688-2.414062-1.832031-3.910156-4.8125-3.671875-8.125.328125-4.59375 4.050781-8.308594 8.644531-8.628906 5.457032-.378906 10 3.9375 10 9.3125 0 3.058594-1.46875 5.777344-3.75 7.476562zm0 0",
    fill: "url(#B)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtection);
export default __webpack_public_path__ + "static/media/icon-protection.45273bcfef587e72ee9deae16ce77c23.svg";
export { ForwardRef as ReactComponent };